import { createActionGroup, props } from '@ngrx/store';
import { GraphqlQueryContext } from '@interfaces/graphql';
import { UserNotificationDeviceForm } from '@interfaces/schema';

/**
 * @description Payload for saving notification device action.
 */
export interface SaveNotificationDevicePayload {
  context?: GraphqlQueryContext;
  form: UserNotificationDeviceForm;
}

/**
 * @description One signal Actions.
 */
export const OneSignalActions = createActionGroup({
  source: 'One Signal',
  events: {
    'Save Notification': props<{ notificationId: string }>(),
    'Save Notification Device': props<SaveNotificationDevicePayload>(),
    'Save Notification Success': props<{ success: boolean }>(),
    'Save Notification Failed': props<{ error: string }>()
  }
});
